module.exports = __webpack_public_path__ + "static/media/screen1.1c75bf07.jpg";